export default "__VITE_ASSET__D6vXZm99__"